import { render, staticRenderFns } from "./ArticleInfoSources.vue?vue&type=template&id=c35ec916&scoped=true"
import script from "./ArticleInfoSources.vue?vue&type=script&lang=ts"
export * from "./ArticleInfoSources.vue?vue&type=script&lang=ts"
import style0 from "./ArticleInfoSources.vue?vue&type=style&index=0&id=c35ec916&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35ec916",
  null
  
)

export default component.exports